import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App'; // Assuming your main component is in App.jsx
import './index.css';
//import './mystyles1.css';

const container = document.getElementById('root');
const root = createRoot(container); // Create a root.
root.render(
<React.StrictMode>
<App />
</React.StrictMode>
);
